import moment from 'moment'

export const cleanData2Table = (prevData, currentData, noData) =>{
    let temp = {
        id: currentData.id_ctrl_audit,
        completed: currentData.completed ? true : false,
        files:[],
        data:[]
    }

    let fixedDataA = [
        currentData.businesses_name ? currentData.businesses_name : noData,
        currentData.rfc ? currentData.rfc : noData,
        currentData.client_status ? currentData.client_status : noData,
        currentData.client_classification ? currentData.client_classification : noData,
        currentData.fiscal_regime ? currentData.fiscal_regime : noData
    ];

    let fixedDataB = [
        currentData.audit_requirements ? currentData.audit_requirements : noData,
        currentData.audit_due_date ? moment(currentData.audit_due_date).format('DD-MM-YYYY') : noData,
        currentData.process ? currentData.process : noData,
        currentData.audit_periodicity ? currentData.audit_periodicity : noData,
        currentData.audit_responsible ? currentData.audit_responsible : noData,
        currentData.audit_comments ? currentData.audit_comments : noData,
        currentData.audit_project_cost ? currentData.audit_project_cost.toString() : noData,
        {key:'audit_documents'},
        currentData.audit_provider ? currentData.audit_provider : noData
    ]

    let varData = [
        {key:'recepit'},
        currentData.process_status ? currentData.process_status : noData,
        currentData.delivery_date ? moment(currentData.delivery_date).format('DD-MM-YYYY') : noData,
        currentData.responsible ? currentData.responsible : noData,
        currentData.notes ? currentData.notes : noData,
        currentData.extra_hours ? currentData.extra_hours : noData,
        {key:'hours_proof'},
        currentData.extra_charges ? currentData.extra_charges : noData,
        {key:'charge_proof'},
        currentData.collections_charge ? currentData.collections_charge : noData,
        currentData.completition_date ? moment(currentData.completition_date).format('DD-MM-YYYY') : noData,
    ]

    let origin_data = {
        process_status_id: currentData.process_status_id,
        delivery_date: currentData.delivery_date,
        responsible_id: currentData.responsible_id,
        notes : currentData.notes,
        extra_hours : currentData.extra_hours,
        extra_charges : currentData.extra_charges,
        collections_charge : currentData.collections_charge,
        completition_date : currentData.completition_date
    }

    let tempA = {...temp}
    tempA.data = [...fixedDataA]
    prevData.fixedDataA.push(tempA);

    let tempB = {...temp}
    tempB.data = [...fixedDataB]
    tempB.files = [
        {id:currentData.id_ctrl_audit,key:'audit_documents',name:'Adjuntar Documentos',path:'auditdocuments',
            status: checkStatus(currentData, 'audit_documents')},
    ]
    prevData.fixedDataB.push(tempB);

    let tempVar = {...temp}
    tempVar.data = [...varData]
    tempVar.files = [
        {id:currentData.id_ctrl_audit,key:'recepit',name:'Acuse',path:'recepit',
            status: checkStatus(currentData, 'recepit')},
        {id:currentData.id_ctrl_audit,key:'hours_proof',name:'Comprobante de horas',path:'hoursproof',
            status: checkStatus(currentData, 'hours_proof')},
        {id:currentData.id_ctrl_audit,key:'charge_proof',name:'Tabla SAT',path:'chargeproof',
            status: checkStatus(currentData, 'charge_proof')}
    ]
    tempVar.origin_data = {...origin_data}
    
    prevData.varData.push(tempVar);
    return prevData;
}

const checkStatus = (item, key) => {
    return item[key] !== "0" && item[key] !== 0 && item[key] !== ""
}
